import React from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';
import { FiPlus, FiFilter, FiMap, FiList, FiTrendingUp } from 'react-icons/fi';

export default function Missions() {
  return (
    <div className="max-w-7xl mx-auto p-8 h-full flex flex-col">
      <header className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">Mission Portfolio</h1>
          <p className="text-slate-600 mt-1">Strategic alignment, execution, and outcomes.</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex bg-slate-100 p-1 rounded-md border border-slate-200">
            <button className="p-1.5 bg-white shadow-sm rounded text-slate-800"><SafeIcon icon={FiList} /></button>
            <button className="p-1.5 text-slate-500 hover:text-slate-800"><SafeIcon icon={FiMap} /></button>
          </div>
          <Button variant="secondary" className="gap-2"><SafeIcon icon={FiFilter} /> Filters</Button>
          <Button className="gap-2"><SafeIcon icon={FiPlus} /> Create Mission</Button>
        </div>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <MissionCard 
          title="Increase Q3 Qualified Pipeline by 20%"
          owner="Sarah Jenkins"
          phase="Deliberation"
          health="on-track"
          stats={{ questions: 3, assumptions: 5, experiments: 1 }}
          impact="$1.2M Target"
        />
        <MissionCard 
          title="Launch EMEA Market Strategy"
          owner="David Chen"
          phase="Execution"
          health="at-risk"
          stats={{ questions: 0, assumptions: 2, experiments: 4 }}
          impact="New Market Entry"
        />
        <MissionCard 
          title="Reduce Customer Acquisition Cost"
          owner="Elena Rostova"
          phase="Ideation"
          health="on-track"
          stats={{ questions: 12, assumptions: 8, experiments: 0 }}
          impact="-15% CAC Target"
        />
        <MissionCard 
          title="Revamp Enterprise Onboarding"
          owner="Marcus Johnson"
          phase="Outcomes"
          health="completed"
          stats={{ questions: 0, assumptions: 0, experiments: 3 }}
          impact="22% Retention Lift"
        />
      </div>
    </div>
  );
}

function MissionCard({ title, owner, phase, health, stats, impact }) {
  const healthColors = {
    'on-track': 'bg-emerald-500',
    'at-risk': 'bg-amber-500',
    'completed': 'bg-blue-500'
  };

  return (
    <Card className="flex flex-col h-full hover:border-blue-200">
      <div className="p-5 flex-1">
        <div className="flex items-start justify-between mb-3">
          <Badge variant={phase === 'Deliberation' ? 'insight' : phase === 'Execution' ? 'ai' : 'neutral'}>
            {phase}
          </Badge>
          <div className="flex items-center gap-1.5 text-xs font-medium text-slate-500">
            <span className={`w-2 h-2 rounded-full ${healthColors[health]}`}></span>
            {health.replace('-', ' ').toUpperCase()}
          </div>
        </div>
        <h3 className="text-lg font-semibold text-slate-900 leading-tight mb-1">{title}</h3>
        <p className="text-sm text-slate-500 mb-6">Owner: {owner}</p>
        
        <div className="grid grid-cols-3 gap-2 py-3 border-y border-slate-100 mb-4">
          <div className="text-center">
            <div className="text-lg font-semibold text-slate-700">{stats.questions}</div>
            <div className="text-[10px] uppercase tracking-wider text-slate-400">Questions</div>
          </div>
          <div className="text-center border-l border-r border-slate-100">
            <div className="text-lg font-semibold text-slate-700">{stats.assumptions}</div>
            <div className="text-[10px] uppercase tracking-wider text-slate-400">Assumptions</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-semibold text-slate-700">{stats.experiments}</div>
            <div className="text-[10px] uppercase tracking-wider text-slate-400">Experiments</div>
          </div>
        </div>
      </div>
      
      <div className="bg-slate-50 p-4 border-t border-slate-100 flex items-center justify-between rounded-b-lg">
        <div className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <SafeIcon icon={FiTrendingUp} className="text-slate-400" />
          {impact}
        </div>
        <button className="text-sm font-medium text-blue-600 hover:text-blue-800">View Details</button>
      </div>
    </Card>
  );
}